// @flow

import _ from 'lodash';

import { toLowerCaseString } from '@zapier/common-utils';

import type { FlattenedState } from '@zapier/editor/src/types';

type Params = {
  query?: FlattenedState,
};

const generateZapTitleFromQuery = ({ query }: Params) => {
  if (!query || !query.headActionLabel || !query.tailActionLabel) {
    return '';
  }

  const {
    headServiceId,
    headServiceName,
    headActionLabel,
    tailServiceId,
    tailServiceName,
    tailActionLabel,
  } = query;

  // When trigger and action apps are the same
  if (headServiceId === tailServiceId) {
    return `${_.upperFirst(
      toLowerCaseString(tailActionLabel)
    )} in ${headServiceName || ''} when ${toLowerCaseString(headActionLabel)}`;
  }

  // When trigger and action apps are different
  return `${_.upperFirst(
    toLowerCaseString(tailActionLabel)
  )} in ${tailServiceName || ''} when ${toLowerCaseString(
    headActionLabel
  )} in ${headServiceName || ''}`;
};

export default generateZapTitleFromQuery;
